import moment from 'moment/moment'

export function csvName (startDate, endDate, name, outlet, outlets) {
  let outletName
  if (outlet.length > 1) {
    outletName = 'All Outlets'
  } else {
    for (let i = 0; i < outlets.length; i++) {
      if (outlet[0] === outlets[i].id) {
        outletName = outlets[i].name
      }
    }
  }

  let dateLabel = startDate.isSame(endDate, 'days') ? moment(startDate).format('DD-MM-YYYY') : [moment(startDate).format('DD-MM-YYYY'), moment(endDate).format('DD-MM-YYYY')].join(' - ')
  let filename = name + ' - ' + dateLabel + ' - ' + outletName
  return filename
}



// WEBPACK FOOTER //
// ./app/utils/formatterCsvName.js